export const getOverflowPivotHeaderId = (id: string) => {
  return `OverflowPivotHeader-${id}`;
};

export const pivotOverflowButtonId = "pivotOverflowButton";
